exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-d994aba6]::-webkit-inner-spin-button,input[data-v-d994aba6]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-d994aba6]{-moz-appearance:textfield}", ""]);

// exports
